module.exports = __webpack_public_path__ + "static/img/masad.e8d59f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/masad.jpg
// module id = pcrL
// module chunks = 6